import { useAmplitudeContext } from '../context/amplitude';

export function useAmplitude<T extends string>() {
  const { amplitude } = useAmplitudeContext();

  const track = (event: T, config: Record<string, any>) => {
    amplitude?.trackEvent(event, config);
  };

  const identify = (userId?: string, userProperties?: Record<string, any>) => {
    amplitude?.identifyUser(userId, userProperties);
  };

  const reset = () => {
    amplitude?.resetUser();
  };

  return { track, identify, reset };
}
